// Freebies bundled into every order, shown in the sidebar's "Free
// features" block and used as the marketing-value anchor in the order
// total's "you're saving" pitch. Single source — change a price here,
// every UI surface picks it up.
export const FREEBIES = [
    {label: 'Free revision policy', price: 20},
    {label: 'Free bibliography & reference', price: 15},
    {label: 'Free title page', price: 5},
    {label: 'Free formatting', price: 10},
];

export const FREEBIES_TOTAL_VALUE = FREEBIES.reduce((sum, f) => sum + f.price, 0);
